









































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import AnnualEITA100000Vue from "../../views/AnnualEITList/AnnualEITA100000.vue";
import AnnualEITA101010Vue from "../../views/AnnualEITList/AnnualEITA101010.vue";
import AnnualEITA102010Vue from "../../views/AnnualEITList/AnnualEITA102010.vue";
import AnnualEITA104000Vue from "../../views/AnnualEITList/AnnualEITA104000.vue";
import AnnualEITA105000Vue from "../../views/AnnualEITList/AnnualEITA105000.vue";
import AnnualEITA105050Vue from "../../views/AnnualEITList/AnnualEITA105050.vue";
import AnnualEITA105060Vue from "../../views/AnnualEITList/AnnualEITA105060.vue";
import AnnualEITA105080Vue from "../../views/AnnualEITList/AnnualEITA105080.vue";
import AnnualEITA106000Vue from "../../views/AnnualEITList/AnnualEITA106000.vue";
import AnnualEITA000000Vue from "../../views/AnnualEITList/AnnualEITA000000.vue";
import AnnualEITA107040Vue from "../../views/AnnualEITList/AnnualEITA107040.vue";
import AnnualEITBalanceVue from "./AnnualEITBalance.vue";
import AnnualEITList, { IncomeTaxAnnualList } from "./AnnualEITList";
import { mapGetters } from "vuex";
@Component({
  ...mapGetters(["accountBook"]),
  components: {
    AnnualEITA100000: AnnualEITA100000Vue,
    AnnualEITA101010: AnnualEITA101010Vue,
    AnnualEITA102010: AnnualEITA102010Vue,
    AnnualEITA104000: AnnualEITA104000Vue,
    AnnualEITA105000: AnnualEITA105000Vue,
    AnnualEITA105050: AnnualEITA105050Vue,
    AnnualEITA105060: AnnualEITA105060Vue,
    AnnualEITA105080: AnnualEITA105080Vue,
    AnnualEITA106000: AnnualEITA106000Vue,
    AnnualEITA000000: AnnualEITA000000Vue,
    AnnualEITA107040: AnnualEITA107040Vue,
    Balance: AnnualEITBalanceVue
  }
})
export default class AnnualEITDialog extends Vue {
  @Prop({ type: Object })
  annualData?: IncomeTaxAnnualList;

  @Prop({ type: Date })
  time?: Date;

  currentView: string = ""; //跳转各个页面的地址
  tableList: any = "";
  tableData: IncomeTaxAnnualList[] = AnnualEITList; //主表
  activeAnnual: string = "";
  create() {}
  mounted() {
    if (this.time) this.dateTime = this.time;
    if (this.annualData) {
      if (this.annualData.name) this.activeAnnual = this.annualData.name;
      if (this.annualData.url) this.currentView = this.annualData.url;
    }
  }
  // 详情跳转各个页面
  changeUrl(url: string) {
    let urlList = "/" + url;
    this.$router.push({ path: urlList });
  }
  changeEIT(val: any) {
    this.activeAnnual = val.name;
    this.currentView = val.url;
  }
  dateTime: Date = this.getTime(); //选择的时间
  getTime() {
    let year = new Date().getFullYear() - 1;
    let time = year + "12" + "01";
    return this.$utils.strToDate(time);
  }
  // 初始化dateTime
  subsidiaryDate: any = [this.dateTime, this.dateTime];
  changeDateTime() {
    this.subsidiaryDate = [this.dateTime, this.dateTime];
    // this.fetchData();
  }
  // 获取时间范围
  get disabledDate() {
    return {
      disabledDate: (time: Date) => {
        return (
          time.getFullYear() < new Date().getFullYear() - 4 ||
          time.getFullYear() > new Date().getFullYear() + 2
        );
      }
    };
  }
}
